import { motion } from '@eversports/react-components/design-tokens/motion'
import { HorizontalFlex, SimpleFlex } from '@eversports/react-components/primitives/Flex'
import Icon from '@eversports/react-components/primitives/Icon'
import TicketIcon from '@eversports/react-components/primitives/Icon/custom-icons/Ticket'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { isConfirmWithOption, isPurchaseOption, SettleWith } from '../../../typings/Product'
import ProductInformation from '../../Product/ProductInformation'

interface Props {
  settleWith: SettleWith
}

const BookingDetailsSettleWith: React.FC<React.PropsWithChildren<Props>> = ({ settleWith }) => {
  const confirmWithOption = isConfirmWithOption(settleWith) && settleWith.product
  const purchaseOption = isPurchaseOption(settleWith) && settleWith
  const settleWithProduct = confirmWithOption || purchaseOption

  if (!settleWithProduct) return null

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ ease: 'easeInOut' }}
    >
      <SimpleFlex>
        <Icon icon={TicketIcon} color="subtleText" marginRight="dense" />
        <HorizontalFlex horizontalSpacing="dense">
          <Text fontWeight="bold" size="small">
            {settleWithProduct.name}
          </Text>
          <ProductInformation product={settleWithProduct} />
        </HorizontalFlex>
      </SimpleFlex>
    </motion.div>
  )
}

export default BookingDetailsSettleWith
